import { Component, OnInit, Input } from '@angular/core';
import { get } from 'http';
import { ApiCallService } from 'src/app/core/services/api-call-service';

@Component({
  selector: 'app-logical-expressions-viewer',
  templateUrl: './logical-expression-viewer.component.html',
  styleUrls: ['./logical-expression-viewer.component.css']
})
export class LogicalExpressionsViewerComponent implements OnInit {

  @Input() logicalExpressions;

  constructor(private apiCall: ApiCallService) { }
  badgeList: any = [];
  apiProductList: any = [];
  productListApiData = {
    pageNo: 1,
    pageSize: 1500,
    maxProductListPrize: null,
  };

  ngOnInit(): void {
    this.getCustomerBadges();
    this.getProduct("");
  }

  getDisplay(value: string): string {
    const displayMap: Record<string, string> = {
      "$amount_spent": "Amount Spent",
      "$places_an_order": "Places an order",
      "$product_purchase": "Customer who",
      "$earn_badge": "Earns a badge",
      "$loyalty_points_earn" : "Loyalty Points Earn",
    };
  
    return displayMap[value] || value; // Return original value if not found
  }

  getOperand2Display(value: string, type: string): string {
    if(type === "$earn_badge"){
      return this.getBadgeNameBasedOnId(value);
    } if (type === "$product_purchase"){
      return this.getProductNameBasedOnId(value);
    } else{
      return value;
    }
  }

  getBadgeNameBasedOnId(id){
    const badge = this.badgeList.find(item => item.id === id);
    return badge?.name;
  }

  getProductNameBasedOnId(id){
    const product = this.apiProductList.find((item) => item.variantId === id);
    return product?.variantName;
  }

  getCustomerBadges() {
    this.apiCall.getBadgesByMerchantId().subscribe((response) => {
      console.log(response);
      let data = response["body"];
      this.badgeList = (data);
    });
  }

  getProduct(char, type?) {
    this.apiCall
      .getOfferManagementProductsList(
        char,
        this.productListApiData.pageNo,
        this.productListApiData.pageSize
      )
      .subscribe(
        (resultList) => {
          let data = resultList["body"];
          let lengthList = [];
          // this.previousChar = this.currentChar;
          this.productListApiData.maxProductListPrize = parseInt(
            Object.keys(data)[0]
          );
          data[Object.keys(data)[0]].forEach((product) =>
            lengthList.push(product.productName)
          );
          console.log(this.productListApiData);
          data[Object.keys(data)[0]].forEach((product) => {
            product?.variants.forEach((prod) => {
              this.apiProductList.push(prod);
            });
          });
          //lazy fetch other products
          if (
            this.productListApiData.maxProductListPrize >
            this.productListApiData.pageNo * this.productListApiData.pageSize
          ) {
            this.productListApiData.pageNo++;
            this.getProduct("");
          }
          //after getting all products
        },
        (error) => {
          console.log("Error fetching product list:", error);
        }
      );
  }

}
